(function () {
  function debounce(fn, ms) {
    var t;
    return function () {
      clearTimeout(t);
      var a = arguments;
      var self = this;
      t = setTimeout(function () {
        fn.apply(self, a);
      }, ms);
    };
  }

  /** Match mega dropdown width + horizontal position to `.header--primary-nav`. */
  function syncNavMegaPanels(selector, readyClass) {
    var nav = document.querySelector('.header--primary-nav');
    if (!nav) return;
    var panels = document.querySelectorAll(selector);
    if (!panels.length) return;

    var navRect = nav.getBoundingClientRect();

    var vw = window.innerWidth;
    var pad = 8;

    panels.forEach(function (panel) {
      var cs = window.getComputedStyle(panel);
      var position = cs.position;
      /* Respect CSS min-width (e.g. 1080px) so JS-applied width never fights the cascade. */
      var minW = parseFloat(cs.minWidth) || 0;
      var width = Math.max(navRect.width, minW);

      panel.style.boxSizing = 'border-box';
      panel.style.width = width + 'px';
      panel.style.maxWidth = width + 'px';
      panel.style.right = 'auto';
      panel.style.transform = 'none';
      panel.style.marginLeft = '0';

      /* Center on nav; clamp inside viewport so wide panels do not overflow either edge. */
      var navCenter = navRect.left + navRect.width / 2;
      var maxLeft = Math.max(pad, vw - width - pad);
      var viewportLeft = Math.max(pad, Math.min(navCenter - width / 2, maxLeft));

      if (position === 'fixed') {
        panel.style.left = viewportLeft + 'px';
        panel.classList.add(readyClass);
        return;
      }

      var op = panel.offsetParent;
      if (!op || op === document.documentElement) {
        op = document.body;
      }
      var opRect = op.getBoundingClientRect();
      panel.style.left = viewportLeft - opRect.left + 'px';
      panel.classList.add(readyClass);
    });
  }

  function syncAllNavMegaPanels() {
    syncNavMegaPanels('[data-brands-mega-panel]', 'brands-mega-panel--layout-ready');
    syncNavMegaPanels('[data-category-mega-panel]', 'category-mega-panel--layout-ready');
  }

  function bindNavMegaPanelLayouts() {
    var hasPanel =
      document.querySelector('[data-brands-mega-panel]') ||
      document.querySelector('[data-category-mega-panel]');
    if (!hasPanel || bindNavMegaPanelLayouts._done) return;
    bindNavMegaPanelLayouts._done = true;

    var sync = debounce(syncAllNavMegaPanels, 80);
    sync();
    requestAnimationFrame(sync);

    window.addEventListener('resize', sync);
    window.addEventListener('scroll', sync, true);

    var nav = document.querySelector('.header--primary-nav');
    if (nav && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(sync).observe(nav);
    }

    setTimeout(function () {
      document.querySelectorAll('[data-brands-mega-panel]').forEach(function (p) {
        if (!p.classList.contains('brands-mega-panel--layout-ready')) {
          p.classList.add('brands-mega-panel--layout-ready');
        }
      });
      document.querySelectorAll('[data-category-mega-panel]').forEach(function (p) {
        if (!p.classList.contains('category-mega-panel--layout-ready')) {
          p.classList.add('category-mega-panel--layout-ready');
        }
      });
    }, 3000);
  }

  function bucketLetter(title) {
    var t = (title || '').trim();
    if (!t.length) return '#';
    var c = t.charAt(0).toUpperCase();
    if (/[0-9]/.test(c)) return '0-9';
    if (/[A-Z]/.test(c)) return c;
    return '#';
  }

  function sortKeys(keys) {
    var hasNum = keys.indexOf('0-9') !== -1;
    var hasHash = keys.indexOf('#') !== -1;
    var letters = keys.filter(function (k) {
      return k !== '0-9' && k !== '#';
    });
    letters.sort();
    var out = [];
    if (hasNum) out.push('0-9');
    letters.forEach(function (l) {
      out.push(l);
    });
    if (hasHash) out.push('#');
    return out;
  }

  function group(items) {
    var map = {};
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var L = bucketLetter(item.title);
      if (!map[L]) map[L] = [];
      map[L].push(item);
    }
    return map;
  }

  /** Row-major grid: 4 brand links per row (CSS `.brands-mega__grid`). */
  function renderColumns(container, items) {
    container.textContent = '';
    var ul = document.createElement('ul');
    ul.className = 'brands-mega__grid';
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = item.url;
      a.textContent = item.title;
      a.setAttribute('data-item', 'sub-nav-text');
      li.appendChild(a);
      ul.appendChild(li);
    }
    container.appendChild(ul);
  }

  /** After letter change, sync XMenu --natural-height (CSS prevents inner flex from shrinking and clipping the footer). */
  function syncBrandsMegaNaturalHeight(megaRoot) {
    var panel = megaRoot.closest('[data-brands-mega-panel]');
    if (!panel) return;

    requestAnimationFrame(function () {
      if (panel.getAttribute('aria-hidden') === 'false') {
        panel.style.setProperty('--height', 'auto');
        panel.style.setProperty('--natural-height', panel.offsetHeight + 'px');
        panel.style.setProperty('--height', 'var(--natural-height)');
      } else {
        panel.style.setProperty('--height', 'auto');
        panel.setAttribute('aria-hidden', 'false');
        panel.style.setProperty('--natural-height', panel.offsetHeight + 'px');
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  }

  /**
   * One-time correction after the page is fully loaded:
   * - theme.js setNaturalHeights() runs in connectedCallback BEFORE our deferred script renders the brand grid.
   * - bindNavMegaPanelLayouts sets width via a debounced call (~80ms), so any earlier measurement uses the wrong width.
   * - window.load fires after assets/layout have settled, so a single remeasure here is correct and doesn’t flicker.
   */
  function remeasureAllBrandsMegaAfterLoad() {
    function remeasure() {
      document.querySelectorAll('[data-brands-mega]').forEach(syncBrandsMegaNaturalHeight);
    }
    if (document.readyState === 'complete') {
      remeasure();
    } else {
      window.addEventListener('load', remeasure, { once: true });
    }
  }

  function init(root) {
    var script = root.querySelector('script[data-brands-json]');
    if (!script) return;
    var items;
    try {
      items = JSON.parse(script.textContent);
    } catch (e) {
      return;
    }
    if (!items || !items.length) return;

    var groups = group(items);
    var keys = sortKeys(Object.keys(groups));
    if (!keys.length) return;

    var alphabetEl = root.querySelector('[data-brands-alphabet]');
    var columnsEl = root.querySelector('[data-brands-columns]');
    if (!alphabetEl || !columnsEl) return;

    function setActive(letter) {
      var k;
      for (var i = 0; i < keys.length; i++) {
        k = keys[i];
        var btn = alphabetEl.querySelector('[data-letter="' + k + '"]');
        if (!btn) continue;
        var on = k === letter;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-current', on ? 'true' : 'false');
      }
      renderColumns(columnsEl, groups[letter] || []);
      syncBrandsMegaNaturalHeight(root);
    }

    alphabetEl.textContent = '';
    for (var j = 0; j < keys.length; j++) {
      var key = keys[j];
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'brands-mega__letter';
      button.setAttribute('data-letter', key);
      button.textContent = key === '0-9' ? '0–9' : key;
      button.addEventListener('mouseenter', function () {
        var L = this.getAttribute('data-letter');
        if (L && groups[L]) setActive(L);
      });
      button.addEventListener('click', function (e) {
        e.preventDefault();
        var L = this.getAttribute('data-letter');
        if (L && groups[L]) setActive(L);
      });
      alphabetEl.appendChild(button);
    }

    setActive(keys[0]);
  }

  function boot() {
    document.querySelectorAll('[data-brands-mega]').forEach(init);
    bindNavMegaPanelLayouts();
    remeasureAllBrandsMegaAfterLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
